// 模块名称与ID标识
let MODULE = [{
    id: CORE,
    name: CORE_NAME
}, {
    id: TOOLBAR,
    name: TOOLBAR_NAME
}, {
    id: MATERIAL,
    name: MATERIAL_NAME
}, {
    id: SCENE,
    name: SCENE_NAME
}, {
    id: ACTION,
    name: ACTION_NAME
}, {
    id: TIMELINE,
    name: TIMELINE_NAME
}, {
    id: HOMEPAGE,
    name: HOMEPAGE_NAME
}, {
    id: PANELRIGHT,
    name: PANELRIGHT_NAME
}, {
    id: CAMERA,
    name: CAMERA_NAME
}, {
    id: STEP,
    name: STEP_NAME
}, {
    id: TEXT,
    name: TEXT_NAME
}, {
    id: AUDIOPANEL,
    name: AUDIOPANEL_NAME
}, {
    id: RECORD,
    name: RECORD_NAME
}, {
    id: BGMUSIC,
    name: BGMUSIC_NAME
}, {
    id: SOUNDEFFECT,
    name: SOUNDEFFECT_NAME
}, {
    id: ACTIONTIMELINE,
    name: ACTIONTIMELINE_NAME
}, {
    id: ACTIONINFO,
    name: ACTIONINFO_NAME
}, {
    id: PARTS,
    name: PARTS_NAME
}, {
    id: PAGE,
    name: PAGE_NAME
}, {
    id: EXPORT,
    name: EXPORT_NAME
}, {
    id: SCENEDETAILS,
    name: SCENEDETAILS_NAME
}, {
    id: PLAYER,
    name: PLAYER_NAME
}, {
    id: ALIGN,
    name: ALIGN_NAME
}]

// 消息传输协议
let Protocol = {}

// 模块初始化
Protocol.onSocketInit = (platform, module) => {
    // 模块初始化挂载全局变量
    window[module] = {}
}

// 模块与服务器建立链接（H5 直连，无操作）
Protocol.onSocketConnect = (platform, module) => {
}

// 模块注册
Protocol.onSocketRegister = (platform, module, moduleId) => {
    // 平台环境 H5
    if (platform == 'h5' || platform == undefined) {
        setTimeout(() => {
            if(window[module] && window[module].domReady) {
                window[module].domReady()
            }
        }, 20)
    }
}

// 发送消息
Protocol.sender = (platform, message) => {
    window.onReceiverMessage(message.packageId, message.senderId,
        message.receiverId, message.timeFlag, message.sessionId,
        message.messageId, message.protoBytes)
}

// 接收消息（H5 经 window.onReceiverMessage 总线转发，无操作）
Protocol.receiver = (platform, module) => {
}

// protobuf 序列化
Protocol.serializeBinary = (new_proto, props) => {
    // protobuf 打包
    let protoMessage = new_proto
    // protobuf 打包格式
    for (let key in props) {
        protoMessage[key](props[key])
    }
    // protobuf 序列化
    let protoBytes = protoMessage.serializeBinary()
    // Uint8Array 转换 Array
    return Array.from(protoBytes)

}

// protobuf 反序列化
Protocol.deserializeBinary = (message, protoBytes) => {

        // Array 转换 Uint8Array
        let arr = new Uint8Array(protoBytes)

        if (message == '') {
            return ''
        } else if (message == 'proto.com.proto.editortimeline.MStepIndex') {
            return proto.com.proto.editortimeline.MStepIndex.deserializeBinary(
                arr)
        } else if (message == 'proto.com.proto.s.MToken') {
            return proto.com.proto.s.MToken.deserializeBinary(arr)
        } else if (message == 'proto.com.proto.s.UserInfo') {
            return proto.com.proto.s.UserInfo.deserializeBinary(arr)
        } else if (message == 'proto.com.proto.material.MMaterial') {
            return proto.com.proto.material.MMaterial.deserializeBinary(arr)
        } else if (message == 'proto.com.proto.s.MTabData') {
            return proto.com.proto.s.MTabData.deserializeBinary(arr)
        } else if (message == 'proto.com.proto.material.MMaterialBack') {
            return proto.com.proto.s.MTabData.deserializeBinary(arr)
        } else if (message == 'proto.com.proto.scene.MStepDetails') {
            return proto.com.proto.scene.MStepDetails.deserializeBinary(arr)
        } else if (message == 'proto.com.proto.scene.MText') {
            return proto.com.proto.scene.MText.deserializeBinary(arr)
        } else if (message == 'proto.com.proto.scene.MSelected') {
            return proto.com.proto.scene.MSelected.deserializeBinary(arr)
        } else if (message == 'proto.com.proto.scene.MAudio') {
            return proto.com.proto.scene.MAudio.deserializeBinary(arr)
        } else if (message == 'proto.com.proto.s.MFloat') {
            return proto.com.proto.s.MFloat.deserializeBinary(arr)
        } else if (message == 'proto.com.proto.scene.MCamera') {
            return proto.com.proto.scene.MCamera.deserializeBinary(arr)
        } else if (message == 'proto.com.proto.toolbar.MToolList') {
            return proto.com.proto.toolbar.MToolList.deserializeBinary(arr)
        } else if (message == 'proto.com.proto.s.MTimelineToolbar') {
            return proto.com.proto.s.MTimelineToolbar.deserializeBinary(arr)
        } else if (message == 'proto.com.proto.s.MTimelineToolbarBack') {
            return proto.com.proto.s.MTimelineToolbarBack.deserializeBinary(arr)
        } else if (message == 'proto.com.proto.toolbar.MToolBarChangeData') {
            return proto.com.proto.toolbar.MToolBarChangeData.deserializeBinary(
                arr)
        } else if (message == 'proto.com.proto.s.MString') {
            return proto.com.proto.s.MString.deserializeBinary(arr)
        } else if (message ==
            'proto.com.proto.actioneditortimeline.MActionGlobalInfo') {
            return proto.com.proto.actioneditortimeline.MActionGlobalInfo.deserializeBinary(
                arr)
        } else if (message ==
            'proto.com.proto.actioneditortimeline.MBundlePartsInfo') {
            return proto.com.proto.actioneditortimeline.MBundlePartsInfo.deserializeBinary(
                arr)
        } else if (message ==
            'proto.com.proto.actioneditortimeline.MSelectPartInfo') {
            return proto.com.proto.actioneditortimeline.MSelectPartInfo.deserializeBinary(
                arr)
        } else if (message == 'proto.com.proto.s.MUint32') {
            return proto.com.proto.s.MUint32.deserializeBinary(arr)
        } else if (message == 'proto.com.proto.s.MInt32') {
            return proto.com.proto.s.MInt32.deserializeBinary(arr)
        } else if (message == 'proto.com.proto.page.MPageList') {
            return proto.com.proto.page.MPageList.deserializeBinary(arr)
        } else if (message == 'proto.com.proto.editortimeline.MStepIndex') {
            return proto.com.proto.editortimeline.MStepIndex.deserializeBinary(
                arr)
        } else if (message == 'proto.com.proto.scene.MDeleteItem') {
            return proto.com.proto.scene.MDeleteItem.deserializeBinary(arr)
        } else if (message == 'proto.com.proto.s.MOpenModule') {
            return proto.com.proto.s.MOpenModule.deserializeBinary(arr)
        } else if (message == 'proto.com.proto.s.MAlert') {
            return proto.com.proto.s.MAlert.deserializeBinary(arr)
        } else if (message == 'proto.com.proto.s.MAlertButton') {
            return proto.com.proto.s.MAlertButton.deserializeBinary(arr)
        } else if (message == 'proto.com.proto.s.MAlertBack') {
            return proto.com.proto.s.MAlertBack.deserializeBinary(arr)
        } else if (message == 'proto.com.proto.s.MFloat') {
            return proto.com.proto.s.MFloat.deserializeBinary(arr)
        } else if (message == "proto.com.proto.s.MMessage") {
            return proto.com.proto.s.MMessage.deserializeBinary(arr);
        } else if (message == "proto.com.proto.s.MMovePage") {
            return proto.com.proto.s.MMovePage.deserializeBinary(arr);
        } else if (message == "proto.com.proto.s.MTextBox") {
            return proto.com.proto.s.MTextBox.deserializeBinary(arr);
        } else if (message == "proto.com.proto.s.MTextBoxBack") {
            return proto.com.proto.s.MTextBoxBack.deserializeBinary(arr);
        } else if (message == "proto.com.proto.scene.MBundleAction") {
            return proto.com.proto.scene.MBundleAction.deserializeBinary(arr);
        } else if (message == "proto.com.proto.scene.MAlign") {
            return proto.com.proto.scene.MAlign.deserializeBinary(arr);
        } else if (message == "proto.com.proto.s.MBool") {
            return proto.com.proto.s.MBool.deserializeBinary(arr);
        }else if (message == "proto.com.proto.s.MStrings"){
            return proto.com.proto.s.MStrings.deserializeBinary(arr);
        }else if (message == "proto.com.proto.scene.MShowFramesSetting"){
            return proto.com.proto.scene.MShowFramesSetting.deserializeBinary(arr);
        }else if (message == "proto.com.proto.scene.MFramesSetting"){
            return proto.com.proto.scene.MFramesSetting.deserializeBinary(arr);
        }else if (message == "proto.com.proto.editortimeline.MPlayTime"){
            return proto.com.proto.editortimeline.MPlayTime.deserializeBinary(arr);
        }else if (message == "proto.com.proto.scene.MShareInfo") {
            return proto.com.proto.scene.MShareInfo.deserializeBinary(arr);
        }
    }
    // protobuf 获取DOM节点
Protocol.domId = (element) => {
    return document.getElementById(element)
}

// H5 消息接收转发服务器
const _onReceiverMessage = function(packageId, senderId, receiverId, timeFlag,
    sessionId, messageId, protoBytes, data){
    
    // 参数验证
    if (typeof packageId === 'undefined' || typeof senderId === 'undefined' || 
        typeof receiverId === 'undefined' || typeof sessionId === 'undefined' || 
        typeof messageId === 'undefined') {
        console.warn('消息参数不完整，跳过处理');
        return;
    }
    
    if (!protoBytes || !Array.isArray(protoBytes)) {
        console.warn('protoBytes 参数无效，跳过处理');
        return;
    }
    
    for (var i = 0; i < MODULE.length; i++) {
        if ((receiverId & MODULE[i].id) > 0) {
            // H5 消息接收转发
            if (MODULE[i].name == 'CORE' ||
                MODULE[i].name == 'TOOLBAR' ||
                MODULE[i].name == 'MATERIAL' ||
                MODULE[i].name == 'TIMELINE' ||
                MODULE[i].name == 'ACTION' ||
                MODULE[i].name == 'HOMEPAGE' ||
                MODULE[i].name == 'PANELRIGHT' ||
                MODULE[i].name == 'CAMERA' ||
                MODULE[i].name == 'STEP' ||
                MODULE[i].name == 'TEXT' ||
                MODULE[i].name == 'AUDIOPANEL' ||
                MODULE[i].name == 'RECORD' ||
                MODULE[i].name == 'BGMUSIC' ||
                MODULE[i].name == 'SOUNDEFFECT' ||
                MODULE[i].name == 'ACTIONINFO' ||
                MODULE[i].name == 'ACTIONTIMELINE' ||
                MODULE[i].name == 'PARTS' ||
                MODULE[i].name == 'PAGE' ||
                MODULE[i].name == 'EXPORT' ||
                MODULE[i].name == 'SCENEDETAILS' ||
                MODULE[i].name == 'ALIGN') {
                if (window[MODULE[i].name] && typeof window[MODULE[i].name].message === 'function') {
                    window[MODULE[i].name].message(senderId, packageId,
                        sessionId, messageId, protoBytes, data)
                } else {
                    console.warn('Module ' + MODULE[i].name + ' message function not found or not a function')
                }
            } else {
            let SWF = Protocol.domId(MODULE[i].name + '-SWF')
            if (SWF && SWF.tagName == 'OBJECT' && SWF.send !==
                undefined) {
                if (localStorage.tab_type == 1) {
                    if (MODULE[i].name !== 'ACTIONTIMELINE') {
                        try {
                            SWF.send(packageId, senderId, receiverId,
                                timeFlag, sessionId, messageId,
                                protoBytes, data)
                        } catch (e) {
                            // 改进异常处理，确保异常对象有效
                            let errorMsg = "SWF send error for " + MODULE[i].name;
                            if (e && typeof e === 'object') {
                                errorMsg += ": " + (e.name || 'Unknown') + " - " + (e.message || 'No message');
                            } else {
                                errorMsg += ": " + String(e);
                            }
                            errorMsg += " (receiverId: " + receiverId + ")";
                            console.warn(errorMsg);
                        }
                    }
                } else if (localStorage.tab_type == 2) {
                        if (MODULE[i].name !== 'TIMELINE') {
                            try {
                                SWF.send(packageId, senderId, receiverId,
                                    timeFlag, sessionId, messageId,
                                    protoBytes, data)
                            } catch (e) {
                                let errorMsg = "SWF send error for " + MODULE[i].name;
                                if (e && typeof e === 'object') {
                                    errorMsg += ": " + (e.name || 'Unknown') + " - " + (e.message || 'No message');
                                } else {
                                    errorMsg += ": " + String(e);
                                }
                                errorMsg += " (receiverId: " + receiverId + ")";
                                console.warn(errorMsg);
                            }
                        }
                    } else if (localStorage.tab_type == 4) {
                        if (MODULE[i].name !== 'TIMELINE' && MODULE[i].name !==
                            'ACTIONTIMELINE') {
                            try {
                                SWF.send(packageId, senderId, receiverId,
                                    timeFlag, sessionId, messageId,
                                    protoBytes, data)
                            } catch (e) {
                                let errorMsg = "SWF send error for " + MODULE[i].name;
                                if (e && typeof e === 'object') {
                                    errorMsg += ": " + (e.name || 'Unknown') + " - " + (e.message || 'No message');
                                } else {
                                    errorMsg += ": " + String(e);
                                }
                                errorMsg += " (receiverId: " + receiverId + ")";
                                console.warn(errorMsg);
                            }
                        }
                    } else {
                        try {
                            SWF.send(packageId, senderId, receiverId,
                                timeFlag, sessionId, messageId,
                                protoBytes, data)
                        } catch (e) {
                            let errorMsg = "SWF send error for " + MODULE[i].name;
                            if (e && typeof e === 'object') {
                                errorMsg += ": " + (e.name || 'Unknown') + " - " + (e.message || 'No message');
                            } else {
                                errorMsg += ": " + String(e);
                            }
                            errorMsg += " (receiverId: " + receiverId + ")";
                            console.warn(errorMsg);
                        }
                    }
                }
            }
        }
    }
}

window.onReceiverMessage = (packageId, senderId, receiverId, timeFlag,
    sessionId, messageId, protoBytes, data) => {
    try{
        _onReceiverMessage(packageId, senderId, receiverId, timeFlag, sessionId, messageId, protoBytes, data);
    } catch(e){
        // 检查异常对象是否有效
        if (e && typeof e === 'object') {
            console.error("onReceiverMessage Error: " + (e.message || 'Unknown error') + "\nstack:\n" + (e.stack || 'No stack trace'));
        } else {
            console.error("onReceiverMessage Error: Invalid exception thrown - " + String(e));
        }
        // 抛出一个有效的错误对象，而不是原始的无效异常
        throw new Error("Protocol message handling failed: " + (e && e.message ? e.message : String(e)));
    }
}


export default Protocol



// WEBPACK FOOTER //
// ./src/common/scripts/protocol.js